import { jsx as _jsx } from "react/jsx-runtime";
const style = {
    maxHeight: "50vh",
};
const ModalBody = ({ children }) => {
    return (_jsx("div", { style: style, className: "px-6 py-4 overflow-y-auto overflow-x-hidden", children: children }));
};
export default ModalBody;
